import React from 'react'

import { Button } from '../../../../../components'
import { REPORT } from '../../../../../helpers/constants'

import Style from './style'

const IssueManagementFooter = (props) => {
  const { language, colorTheme, onOpenReportModal } = props

  return (
    <Style colorTheme={colorTheme}>
      <div className='issue-footer-message-layout'>
        <div className='issue-footer-title'>{REPORT.FACILITY_MAINTENANCE[language]}</div>
        <div className='issue-footer-sub-title'>{REPORT.PROVIDE_ISSUE[language]}</div>
      </div>
      
      <Button
        name={REPORT.REPORT[language]}
        className='report-button'
        onClick={() => onOpenReportModal(true)}
      />
    </Style>
  )
}

export default IssueManagementFooter
